import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-313a1f68"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "用户登录", -1))
const _hoisted_3 = { class: "wrap-inner" }
const _hoisted_4 = { class: "wrapper" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "tip" }

import { ref, reactive, computed, watch } from 'vue'
import { useStore } from 'vuex'
import { ElMessageBox } from 'element-plus'
import { useRouter, useRoute } from 'vue-router'
import { Plus } from '@element-plus/icons-vue'
import Agreement from '@/components/Agreement.vue'
import qs from 'qs'
import { Api } from '@/services/http'
import * as user from '@/libs/user'
import type {
  ComponentSize,
  FormInstance,
  FormRules,
  RuleForm,
} from 'element-plus'
import router from '@/router'
import store from '@/store'


export default /*#__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props) {

const agree = ref(true)
const formData = reactive({
  username: '',
  password: '',
  imageCode:'',
  verificationCode: '',
})
const route = useRoute()
const form = ref(null)

const rules = reactive<FormRules<RuleForm>>({
  username: [
    { required: true, message: '请输入手机号', trigger: 'blur' },
    {
      pattern: /^1[3-9]\d{9}$/,
      message: '手机号格式不正确',
      trigger: 'blur',
    },
  ],
  password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
})

function sendCode() {
  console.log('发送验证码到', this.form.phone)
}
function sendForm(form) {
  form.validate(async valid => {
    const payload = { ...formData, header: 1 }
    if (valid) {
      const res: any = await Api.post(
        `/client-api/wx/loginByPhone`,
        qs.stringify(payload)
      )
      console.log('res', res)
      const token = res.data
      if (token) {
        localStorage.setItem('token', token)
        store.dispatch('user/updateUserInfo')

        let path = route.path
        if (path.indexOf('/user/') != -1) {
          //在登录页
          const ref = route.query.ref
          console.log('ref', ref)
          if (ref) {
            const refPath = (ref + '').replace(/https?:\/\/[^\/]+/gi, '')
            router.replace(refPath)
          } else {
            router.replace('/')
          }
        }
      }
    }
  })
}
const changeImageCode = async ()=>{
  const code = await Api.get('/system/security/verification/code')
  formData.imageCode = code.img
  console.log('code',code)
}
async function mounted(){
  await changeImageCode()
}
mounted();

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_form, {
        model: formData,
        ref_key: "form",
        ref: form,
        rules: rules,
        "label-width": "100px",
        "label-position": "top"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "手机号",
            prop: "username"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: formData.username,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.username) = $event)),
                placeholder: "请输入手机号",
                size: "large",
                maxlength: 11
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "验证码",
            prop: "verificationCode"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_el_input, {
                  modelValue: formData.verificationCode,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.verificationCode) = $event)),
                  size: "large",
                  placeholder: "请输入验证码"
                }, null, 8, ["modelValue"]),
                _createElementVNode("img", {
                  class: "image-code",
                  src: `data:image/png;base64,${formData.imageCode}`,
                  onClick: changeImageCode
                }, null, 8, _hoisted_5)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "密码",
            prop: "password"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                type: "password",
                size: "large",
                modelValue: formData.password,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.password) = $event)),
                placeholder: "输入密码"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(Agreement, {
                agree: agree.value,
                "onUpdate:agree": _cache[3] || (_cache[3] = ($event: any) => ((agree).value = $event))
              }, null, 8, ["agree"]),
              _createElementVNode("div", null, [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (sendForm(form.value))),
                  size: "large",
                  disabled: !agree.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("登录")
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createElementVNode("span", _hoisted_6, [
                  _createTextVNode("没有帐号？"),
                  _createVNode(_component_router_link, { to: "/user/register" }, {
                    default: _withCtx(() => [
                      _createTextVNode("注册")
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ])
  ]))
}
}

})